import { GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const turbulence: Palette[] = [
    {
        name: 'EDR Turbulence',
        id: GDFPalletCode.turb_edr,
        type: 'discreteBar',
        values: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9],
        colors: ['#C6F1C6', '#86E186', '#EFE800', '#F4B700', '#FA8500', '#FD5700', '#ED4200', '#DD2C00', '#CC1600', '#630000']
    },
    {
        id: GDFPalletCode.turb_cat,
        name: 'Clear air turbulence',
        type: 'categorical',
        entries: [
            {
                label: '',
                color: '#000',
                hide: true
            },

            {
                label: 'Light',
                color: '#D6F400'
            },
            {
                label: 'Moderate',
                color: '#FF8C00'
            },
            {
                label: 'Severe',
                color: '#F30000'
            },
            {
                label: 'Extreme',
                color: '#7A0000'
            }
        ]
    },
    {
        id: GDFPalletCode.gtg,
        name: 'GTG Nowcast EDR turbulence',
        type: 'categorical',
        entries: [
            {
                label: '',
                color: '#000',
                hide: true
            },
            {
                label: 'Light',
                color: '#C2ABD3'
            },
            {
                label: 'Light',
                color: '#C2ABD3',
                hide: true
            },
            {
                label: 'Light to Occ. Moderate',
                color: '#A381BD'
            },
            {
                label: 'Moderate',
                color: '#8557A7'
            },
            {
                label: 'Moderate or greater',
                color: '#662d91'
            },
            {
                label: 'Moderate or greater',
                color: '#662d91',
                hide: true
            },
            {
                label: 'Moderate or greater',
                color: '#662d91',
                hide: true
            }
        ]
    },
    {
        name: 'EDR turbulence',
        id: GDFPalletCode.sehzd_turb,
        type: 'discreteBar',
        values: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9],
        colors: ['#0000C0', '#008000', '#00C000', '#00E100', '#808000', '#C0C000', '#C00000', '#FF0000', '#800080', '#FF00FF']
    },
    {
        name: 'IATA Turbulence reports',
        id: GDFPalletCode.iata_turb_severity_iata_gray,
        type: 'categorical',
        entries: [
            { label: '', color: '#808080', hide: true },
            { label: 'Light', color: '#008001' },
            { label: 'Moderate', color: '#ffff01' },
            { label: 'Severe', color: '#ff0000' },
            { label: 'Extreme', color: '#ff02ff' }
        ]
    },
    {
        name: 'IATA Turbulence reports',
        id: GDFPalletCode.iata_turb_severity_iata_white,
        type: 'categorical',
        entries: [
            { label: '', color: '#ffffff', hide: true },
            { label: 'Light', color: '#008001' },
            { label: 'Moderate', color: '#ffff01' },
            { label: 'Severe', color: '#ff0000' },
            { label: 'Extreme', color: '#ff02ff' }
        ]
    },
    {
        name: 'IATA Turbulence reports',
        id: GDFPalletCode.iata_turb_severity_industry_gray,
        type: 'categorical',
        entries: [
            { label: '', color: '#808080', hide: true },
            { label: 'Light', color: '#d6f400' },
            { label: 'Moderate', color: '#ff8d00' },
            { label: 'Severe', color: '#f30000' },
            { label: 'Extreme', color: '#7a0000' }
        ]
    },
    {
        name: 'IATA Turbulence reports',
        id: GDFPalletCode.iata_turb_severity_industry_white,
        type: 'categorical',
        entries: [
            { label: '', color: '#ffffff', hide: true },
            { label: 'Light', color: '#d6f400' },
            { label: 'Moderate', color: '#ff8d00' },
            { label: 'Severe', color: '#f30000' },
            { label: 'Extreme', color: '#7a0000' }
        ]
    },
    {
        name: 'IATA Turbulence reports',
        id: GDFPalletCode.iata_turb_edr_white,
        type: 'categorical',
        entries: [
            { label: '0.0', color: '#ffffff' },
            { label: '> 0.0 to < 0.1', color: '#c6f1c6' },
            { label: '0.1 to < 0.2', color: '#86e186' },
            { label: '0.2 to < 0.3', color: '#efe800' },
            { label: '0.3 to < 0.4', color: '#f4b700' },
            { label: '0.4 to < 0.5', color: '#fa8500' },
            { label: '0.5 to < 0.6', color: '#fd5700' },
            { label: '0.6 to < 0.7', color: '#ed4200' },
            { label: '0.7 to < 0.8', color: '#dd2c00' },
            { label: '0.8 to < 0.9', color: '#cc1600' },
            { label: '0.9 to 1.0', color: '#630000' }
        ]
    },
    {
        name: 'IATA Turbulence reports',
        id: GDFPalletCode.iata_turb_edr_gray,
        type: 'categorical',
        entries: [
            { label: '0.0', color: '#808080' },
            { label: '> 0.0 to < 0.1', color: '#c6f1c6' },
            { label: '0.1 to < 0.2', color: '#86e186' },
            { label: '0.2 to < 0.3', color: '#efe800' },
            { label: '0.3 to < 0.4', color: '#f4b700' },
            { label: '0.4 to < 0.5', color: '#fa8500' },
            { label: '0.5 to < 0.6', color: '#fd5700' },
            { label: '0.6 to < 0.7', color: '#ed4200' },
            { label: '0.7 to < 0.8', color: '#dd2c00' },
            { label: '0.8 to < 0.9', color: '#cc1600' },
            { label: '0.9 to 1.0', color: '#630000' }
        ]
    },
    {
        name: 'TAPS',
        id: GDFPalletCode.taps,
        type: 'categorical',
        entries: [
            { label: 'No data', color: 'gray' },
            { label: 'Heartbeat', color: 'blue' },
            { label: '0.0g < 0.075g', color: 'white' },
            { label: '0.075g < 0.1g', color: 'green' },
            { label: '0.1g < 0.2g', color: 'lightGreen' },
            { label: '0.2g < 0.3g', color: 'yellow' },
            { label: '> 0.3g', color: 'red' }
        ]
    }
];
